<div class="io-row align-items-center">
  <strong class="no-flex">{{ ('placeholder_'+key+'_'+title) | translate }}</strong>
  <small>{{ ('placeholder_'+key+'_'+description) | translate }}</small>

  <div class="no-flex">
    <ng-content></ng-content>
  </div>
</div>